<!--安装订单上传图片页-->
<template>
    <div id="that">
        <div style="padding: 10px 0px 0px 0px">
            <van-icon name="arrow-left" style="float: left" size="20px" @click="onback"/>
        </div>
        <div style="height: 40px"></div>
        <div class="demo-upload-list" v-for="item in uploadList">
            <template v-if="item.status === 'finished'">
                <img :src="item.url">
                <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(item.name)"></Icon>
                    <!--     不设删除   -->
                    <!--        <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>-->
                </div>
            </template>
            <template v-else>
                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
        </div>
        <!--  iview的组件  -->
        <Upload
                ref="upload"
                :show-upload-list="false"
                :default-file-list="defaultList"
                :on-success="handleSuccess"
                :on-error="handleerror"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                multiple
                type="select"
                action="https://upload-z2.qiniup.com"
                style="display: inline-block;width:58px;">
            <div style="width: 58px;height:58px;line-height: 58px;">
                <Icon type="ios-camera" size="20"></Icon>
            </div>
        </Upload>
        <Modal title="图片预览" v-model="visible">
            <!--      <img :src="imageurl" v-if="visible" style="width: 100%">-->
            <!--   <img :src="'https://pic.jianchengjt.com/' + item.picKey + '?imageView2/2/w/300/h/200'">-->


            <img @click="onPhotoClick"
                 :src="'https://pic.jianchengjt.com/' + itempicKey + '?imageView2/2/w/300/h/200'"></img>


        </Modal>
        <div v-if="uploadFile !== null">上传文件: {{uploadFile.name}}
            <van-button type="info" @click="upload" :loading="loadingStatus">{{loadingStatus?'正在上传':'点击上传文件'}}
            </van-button>
        </div>

        <div style="height: 50px"></div>
        <Select v-model="addPictureRecord.picType">
            <Option v-for="item in picTypeList" :value="item.val" :key="item.val">{{item.name}}</Option>
        </Select>
        <div style="height: 50px"></div>

        <div>
            <Table highlight-row size="small" @on-row-click="onRowClick" height="600" :columns="columns"
                   :data="pictureRecords"
                   ref="table"></Table>
        </div>


    </div>
</template>
<script>
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import axios from 'axios'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        inject: ['reload'],
        data() {
            return {
                //返回路径
                onbackid:null,

                columns: [
                    {
                        title: 'picKey',
                        key: 'picKey',
                        ellipsis: 'true',
                        minWidth: 250,
                    },
                    {
                        title: '图片类型',
                        key: 'picType',
                        ellipsis: 'true',
                        minWidth: 100,
                        render: (h, params) => {
                            return h('Select', {
                                    style: {width: '80px'},
                                    props: {
                                        // value: this.data[params.index].volumeType,
                                        value: params.row.picType,
                                        disabled: !params.row.modify
                                    },
                                    on: {
                                        'on-change': (event) => {
                                            params.row.picType = event
                                            console.log(params.row.picType)
                                        }
                                    }
                                },
                                [
                                    h('Option', {
                                        props: {
                                            value: 1
                                        }
                                    }, '合格证'),
                                    h('Option', {
                                        props: {
                                            value: 2
                                        }
                                    }, '登记证1'),
                                    h('Option', {
                                        props: {
                                            value: 3
                                        }
                                    }, '登记证2'),
                                    h('Option', {
                                        props: {
                                            value: 4
                                        }
                                    }, '行驶证'),
                                    h('Option', {
                                        props: {
                                            value: 5
                                        }
                                    }, '车身照'),
                                    h('Option', {
                                        props: {
                                            value: 6
                                        }
                                    }, '货运转网合同'),
                                    h('Option', {
                                        props: {
                                            value: 7
                                        }
                                    }, '货运转网授权书'),
                                    h('Option', {
                                        props: {
                                            value: 8
                                        }
                                    }, '身份识别证件'),
                                    h('Option', {
                                        props: {
                                            value: 9
                                        }
                                    }, '行驶证副页'),
                                    h('Option', {
                                        props: {
                                            value: 10
                                        }
                                    }, '交通局转网授权书'),
                                    h('Option', {
                                        props: {
                                            value: 11
                                        }
                                    }, '身份识别证件背面'),
                                    h('Option', {
                                    props: {
                                        value: 12
                                    }
                                }, '道路运输许可证'),
                                    h('Option', {
                                        props: {
                                            value: 13
                                        }
                                    }, '营业执照'),
                                    h('Option', {
                                        props: {
                                            value: 14
                                        }
                                    }, '安装证明')
                                ]
                            );
                        }
                    },
                ],
                defaultList: [

                    // {
                    //   'name': 'a42bdcc1178e62b4694c830f028db5c0',
                    //   'url': 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1569562652557&di=13452092df65ad912a597e9d81525a6f&imgtype=0&src=http%3A%2F%2Fwx2.sinaimg.cn%2Forj360%2F70410f81ly1g62kybfo01j20u00gdadz.jpg'
                    // },
                    // {
                    //   'name': 'bc7521e033abdd1e92222d733590f104',
                    //   'url': 'https://o5wwk8baw.qnssl.com/bc7521e033abdd1e92222d733590f104/avatar'
                    // }
                ],
                imgName: '',
                imageurl: '',
                itempicKey: '',
                visible: false,
                uploadList: [],


                loadingStatus: false,

                addPictureRecord: {
                    picKey: null,
                    srcHeight: null,
                    srcWidth: null,
                    picType: 1
                },
                picTypeList: [
                    {name: '合格证', val: 1},
                    {name: '登记证1', val: 2},
                    {name: '登记证2', val: 3},
                    {name: '行驶证', val: 4},
                    {name: '行驶证副页', val: 9},
                    {name: '车身照', val: 5},
                    {name: '货运转网合同', val: 6},
                    {name: '货运转网授权书', val: 7},
                    {name: '身份识别证件', val: 8},
                    {name: '身份识别证件背面', val: 11},
                    {name: '交通局转网授权书', val: 10},
                    {name: '道路运输许可证', val: 12},
                    {name: '营业执照', val: 13},
                    {name: '安装证明', val: 14}
                ],
                postParams: {
                    upload_token: null,
                    picKey:null
                },
                uploadFile: null,
                pictureRecords: [],

            }
        },
        methods: {
            //返回上一页
            onback(){
                this.$router.push({
                    path: this.onbackid,
                    query:{'installid':this.$route.query.item}

                    // name: this.onbackid,
                    // params: {'installid': this.$route.query.item}
                })
            },
            onRowClick(item, index) {
                console.log(item.picKey)
                // console.log(index)
                this.visible = true
                this.itempicKey = item.picKey
                this.currentPictureIndex = index;
                let item2 = this.pictureRecords[this.currentPictureIndex]
                // window.open('https://pic.jianchengjt.com/' + item2.picKey)
            },
            onPhotoClick() {

                for (let i = 0; i < this.pictureRecords.length; i++) {

                }


                let item = this.pictureRecords[this.currentPictureIndex]
                window.open('https://pic.jianchengjt.com/' + item.picKey)
            },

            loadPhotoRecords() {
                store.dispatch('InstallOrderServ_GetDetail', {
                    params: {id: this.$route.query.item},
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    let installOrder = store.getters.get_InstallOrder_GetDetailResult
                    let vehicleInfo = null
                    if (installOrder.tempVehicleInfo!=null){
                        vehicleInfo = installOrder.tempVehicleInfo

                        console.log(vehicleInfo)
                        this.pictureRecords = []
                        if (vehicleInfo.vehicleBodyPicture) {
                            console.log('111')
                            this.pictureRecords.push(vehicleInfo.vehicleBodyPicture)
                        }
                        if (vehicleInfo.vehicleSrcLicensePicture2) {
                            console.log('222')
                            this.pictureRecords.push(vehicleInfo.vehicleSrcLicensePicture2)
                        }
                        if (vehicleInfo.vehicleSrcLicensePicture1) {
                            console.log('333')
                            this.pictureRecords.push(vehicleInfo.vehicleSrcLicensePicture1)
                        }
                        if (vehicleInfo.certificatePicture) {
                            console.log('444')
                            this.pictureRecords.push(vehicleInfo.certificatePicture)
                        }
                        if (vehicleInfo.vehicleLicensePicture) {
                            console.log('555')
                            this.pictureRecords.push(vehicleInfo.vehicleLicensePicture)
                        }
                        if (vehicleInfo.qghyptChangeContractPicture) {
                            console.log('666')
                            this.pictureRecords.push(vehicleInfo.qghyptChangeContractPicture)
                        }
                        if (vehicleInfo.qghyptChangeAuthorizationPicture) {
                            console.log('777')
                            this.pictureRecords.push(vehicleInfo.qghyptChangeAuthorizationPicture)
                        }
                        if (vehicleInfo.idFilePicture) {
                            console.log('888')
                            this.pictureRecords.push(vehicleInfo.idFilePicture)
                        }
                        if (vehicleInfo.vehicleLicenseFlapPicture) {
                            console.log('999')
                            this.pictureRecords.push(vehicleInfo.vehicleLicenseFlapPicture)
                        }
                        if (vehicleInfo.jtjChangeAuthorizationPicture) {
                            console.log('jjj')
                            this.pictureRecords.push(vehicleInfo.jtjChangeAuthorizationPicture)
                        }
                        if (vehicleInfo.idFileBackPicture) {
                            console.log('qqq')
                            this.pictureRecords.push(vehicleInfo.idFileBackPicture)
                        }
                        if (vehicleInfo.roadTransportationPermitCardPicture) {
                            console.log('kkk')
                            this.pictureRecords.push(vehicleInfo.roadTransportationPermitCardPicture)
                        }
                        if (vehicleInfo.businessLicensePicture) {
                            console.log('lll')
                            this.pictureRecords.push(vehicleInfo.businessLicensePicture)
                        }
                        if (vehicleInfo.installationCertificatePicture) {
                            console.log('mmm')
                            this.pictureRecords.push(vehicleInfo.installationCertificatePicture)
                        }
                        // this.pictureRecords.forEach(item => {console.log('999')
                        //  Vue.set(item, 'modify', false)
                        // });
                    } else {
                        store.dispatch('VehicleInfoServ_GetDetail', {
                            params: {id: installOrder.vehicleInfoId},
                            urlparams: null
                        }).then((res) => {
                            vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult
                            this.pictureRecords = []
                            if (vehicleInfo.vehicleBodyPicture) {
                                console.log('111')
                                this.pictureRecords.push(vehicleInfo.vehicleBodyPicture)
                            }
                            if (vehicleInfo.vehicleSrcLicensePicture2) {
                                console.log('222')
                                this.pictureRecords.push(vehicleInfo.vehicleSrcLicensePicture2)
                            }
                            if (vehicleInfo.vehicleSrcLicensePicture1) {
                                console.log('333')
                                this.pictureRecords.push(vehicleInfo.vehicleSrcLicensePicture1)
                            }
                            if (vehicleInfo.certificatePicture) {
                                console.log('444')
                                this.pictureRecords.push(vehicleInfo.certificatePicture)
                            }
                            if (vehicleInfo.vehicleLicensePicture) {
                                console.log('555')
                                this.pictureRecords.push(vehicleInfo.vehicleLicensePicture)
                            }
                            if (vehicleInfo.qghyptChangeContractPicture) {
                                console.log('666')
                                this.pictureRecords.push(vehicleInfo.qghyptChangeContractPicture)
                            }
                            if (vehicleInfo.qghyptChangeAuthorizationPicture) {
                                console.log('777')
                                this.pictureRecords.push(vehicleInfo.qghyptChangeAuthorizationPicture)
                            }
                            if (vehicleInfo.idFilePicture) {
                                console.log('888')
                                this.pictureRecords.push(vehicleInfo.idFilePicture)
                            }
                            if (vehicleInfo.vehicleLicenseFlapPicture) {
                                console.log('999')
                                this.pictureRecords.push(vehicleInfo.vehicleLicenseFlapPicture)
                            }
                            if (vehicleInfo.jtjChangeAuthorizationPicture) {
                                console.log('jjj')
                                this.pictureRecords.push(vehicleInfo.jtjChangeAuthorizationPicture)
                            }
                            if (vehicleInfo.idFileBackPicture) {
                                console.log('qqq')
                                this.pictureRecords.push(vehicleInfo.idFileBackPicture)
                            }
                            if (vehicleInfo.roadTransportationPermitCardPicture) {
                                console.log('kkk')
                                this.pictureRecords.push(vehicleInfo.roadTransportationPermitCardPicture)
                            }
                            if (vehicleInfo.businessLicensePicture) {
                                console.log('lll')
                                this.pictureRecords.push(vehicleInfo.businessLicensePicture)
                            }
                            if (vehicleInfo.installationCertificatePicture) {
                                console.log('mmm')
                                this.pictureRecords.push(vehicleInfo.installationCertificatePicture)
                            }
                            // this.pictureRecords.forEach(item => {console.log('999')
                            //  Vue.set(item, 'modify', false)
                            // });
                        }).catch(err=>{
                            console.log(err)
                        })
                    }
                }).catch(err => {
                    this.$Message.error(err)
                })
            },
            success() {
                this.$Message.success('This is a success tip');
                store.dispatch('InstallOrderServ_ConfirmUpload', {
                    params: {
                        id: null,
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                }).catch((err) => {
                    console.log(err)
                })
            },
            warning() {
                this.$Message.warning('This is a warning tip');
            },
            error() {
                this.$Message.error('This is an error tip');
            },
            onFind() {
                this.success()
            },
            handleView(name) {
                console.log(name)
                for (let i = 0; i < this.defaultList.length; i++) {
                    // console.log(this.defaultList[i].name)
                    if (name == this.defaultList[i].name) {
                        this.imageurl = this.defaultList[i].url
                    }
                }
                this.imgName = name;
                this.visible = true;
            },
            handleRemove(file) {
                const fileList = this.$refs.upload.fileList;
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
            },
            //文件上传成功时的钩子，返回字段为 response, file, fileList
            handleSuccess(res, file) {
                console.log('success'+file)
                // file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
                // file.name = '7eb99afb9d5f317c912f08b5212fd69a';
                // file.url = 'http://pic41.nipic.com/20140522/13975662_164750011385_2.jpg';
                //显示的图片，push
                this.defaultList.push(
                    {
                        'name': file.name,
                        'url': file.url
                    }
                )
            },
            handleerror(file){
                Toast('上传失败'+file)
                console.log('error'+file)
            },
            //文件格式验证失败时的钩子，返回字段为 file, fileList
            handleFormatError(file) {
                console.log(file)
                this.$Notice.warning({
                    title: 'The file format is incorrect',
                    desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
                });
            },
            //限制图片大小
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: 'Exceeding file size limit',
                    desc: 'File  ' + file.name + ' is too large, no more than 2M.'
                });
            },
            //上传文件之前的钩子，参数为上传的文件，若返回 false 或者 Promise 则停止上传
            handleBeforeUpload(file) {
                let that = this;
                // Toast('text!!!')
                // const check = this.uploadList.length < 5;
                // if (!check) {
                //  this.$Notice.warning({
                //   title: 'Up to five pictures can be uploaded.'
                //  });
                // }


                //获取七牛上传凭证
                store.dispatch('PictureServ_GetQiniuUploadToken', {
                    params: {
                        head: 'INSTALLORDER'
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    that.postParams.upload_token = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                    that.postParams.picKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                    that.uploadFile = file;
                    // this.upload()
                })
                    .catch((err) => {
                        console.log(err)
                    })

                return false;
            },

            upload() {
                console.log('开始上传')
                let param = new FormData(); //创建form对象
                param.append('chunk', '0');//断点传输
                param.append('chunks', '1');
                param.append('token', this.postParams.upload_token)
                param.append('key', this.postParams.picKey);
                param.append('file', this.uploadFile, this.uploadFile.name)
                console.log(this.uploadFile)

                let config = {
                    // headers:{'X-Requested-with':'XMLHttpRequest'},
                    // headers:{'Content-Type':'application/json'},
                    headers: {'Content-Type': 'multipart/form-data'},
                    // headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}  // 这里是跨域的写法
                    withCredentials: false
                };
                this.loadingStatus = true;

                console.log(this.postParams.picKey)
                console.log(this.addPictureRecord.picType)


                        axios.post('https://upload-z2.qiniup.com', param, config)
                            .then(response => {
                                console.log(response);
                                console.log(response.data);
                                // this.addPictureRecord.picKey = this.postParams.picKey

                                // console.log(this.addPictureRecord)

                                //  未完成的订单
                                //安装订单更换图片
                                store.dispatch('InstallOrderServ_ChangePicture', {
                                    params: {
                                        id: this.$route.query.item,
                                        picKey: this.postParams.picKey,
                                        picType: this.addPictureRecord.picType,
                                        srcWidth: this.addPictureRecord.srcWidth,
                                        srcHeight: this.addPictureRecord.srcHeight
                                    },
                                    urlparams: null
                                }).then((res) => {
                                    console.log(res)
                                    this.loadingStatus = false
                                    Toast.success('添加图片成功')
                                    this.uploadFile = null
                                    this.reload()
                                    this.loadPhotoRecords()
                                }).catch(err => {
                                    this.loadingStatus = false
                                    Toast(err)
                                });

                            }).catch(err1 => {
                            Toast(err1)
                            this.loadingStatus = false
                        })
            },


        },
        mounted() {
            this.uploadList = this.$refs.upload.fileList;
            console.log(this.$root.installid)
            console.log(this.$route.query)
            this.onbackid = this.$route.query.install
            this.loadPhotoRecords()

        }
    }
</script>
<style>
    .father:hover .element {
        display: block;
    }

    .demo-upload-list {
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 4px;
    }

    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, .6);
    }

    .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
    }

    .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }

    #that {
        height: 100%;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
</style>
